// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__f3AMX"};